<template lang="pug">

  nav
    ul.pagination-wrapper
      li
        .custom-select
          select(v-model="pageSize" v-on:change="onChange")
            option(value="20") Show 20 users per page
            option(value="50") Show 50 users per page
            option(value="100") Show 100 users per page
      li(v-if="!loading && totalCount")
        p
        | Showing {{firstResult}} - {{lastResult}} of {{totalCount}} results
      li
        ul.pagination-links
          li.prev(v-bind:class="{ disabled: hidePrevious }" v-on:click.prevent="onPrevious")
            a(href="#") &lt; Prev
          li.next(v-bind:class="{ disabled: hideNext }" v-on:click.prevent="onNext")
            a(href="#") Next &gt;

</template>

<script>
export default {
  name: 'PatientPagination',
  props: {
    initialPageSize: {
      validator: function(value) {
        return (value === 20 || value === 50 || value === 100);
      }
    },
    initialPage: {
      type: Number,
      required: true
    },
    changePage: {
      type: Function,
      required: true
    },
    loading: {
      type: Boolean
    },
    totalCount: {
      type: null
    }
  },
  data() {
    return {
      page: this.initialPage,
      pageSize: this.initialPageSize
    };
  },
  computed: {
    hidePrevious() {
      return this.page === 1;
    },
    hideNext() {
      return this.loading ? true
        : (this.page * this.pageSize) > this.totalCount;
    },
    firstResult() {
      if (this.loading) {
        return '';
      }
      return (this.page - 1) * this.pageSize;
    },
    lastResult() {
      if (this.loading) {
        return '';
      }
      let last = this.page * this.pageSize;
      return this.totalCount < last ? this.totalCount : last;
    }
  },
  methods: {
    onChange: function(newPage) {
      let page = 1;
      let pageSize = parseInt(this.pageSize);

      if (this.pageSize === this.initialPageSize) {
        page = this.page;
      }

      this.changePage({
        pageSize,
        page
      });

      window.scrollTo(0, 0);
    },
    onPrevious: function() {
      this.page--;
      this.onChange();
    },
    onNext: function() {
      this.page++;
      this.onChange();
    }
  },
  watch: {
    initialPageSize(newPageSize) {
      this.pageSize = newPageSize;
    },
    initialPage(newPage) {
      this.page = newPage;
    }
  }
};
</script>

<style lang="scss" scoped>

  nav {
    margin: 0 auto;
    padding: 0 0 $base-spacing 0;
  }
  .pagination-wrapper {
    margin: 0 auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }

  .pagination-links {
    @include zero;
      background: #fff;
      border: 1px solid $base-border-color;
      border-radius: $base-border-radius;
    li {
      display: inline-block;
    }
    li.current {
      padding: $xs-spacing $small-spacing;
      background: $base-border-color;
      color: #fff;
    }
    li.disabled {
      pointer-events: none;
      opacity: 0.5;
      a {
        color: $grey;
      }
    }
    a {
      display: block;
      padding: $xs-spacing $small-spacing;
      &:hover, &:focus {
        background: $action-color;
        color: #fff;
      }
    }
  }
</style>
